import React, { Component } from "react";
import { Switch } from "react-router";
import { Layout } from "./Layout";
import { RouteWithLayout } from "./RouteWithLayout";
import { ContactServicePage } from "../pages/contact-service/ContactServicePage";

export class ContactServiceSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={Layout} exact path="/" component={ContactServicePage} />
      </Switch>
    );
  }
}
